import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import { Row, Col } from 'reactstrap';
import { withTracker } from 'components/Tracker';
import qs from 'query-string';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { BasicMain, injectIntl } from 'components';
import immutableToJS from 'helpers/immutableToJS';
import { isMobile } from 'helpers/detect-mobile';
import { selectState } from 'redux/selectors';

import ProductCard from './components/ProductCard';

const categories = [
  { name: 'small', label: 'Small box', mobileLabel: 'Small box' },
  // { name: 'medium', label: 'Medium box', mobileLabel: 'Medium box' },
  // { name: 'large', label: 'X-Large box', mobileLabel: 'X-Large box' },
];

const styles = theme => ({
  actions: { textAlign: 'center', marginBottom: theme.spacing.unit * 5 },
  button: { margin: isMobile ? theme.spacing.unit / 4 : theme.spacing.unit, outline: 'none' },
  bottomSpacing: { marginBottom: theme.spacing.unit * 3 },
});

class Products extends Component {
  static propTypes = {
    classes: PropTypes.shape({}).isRequired,
    features: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    formatMessage: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      category: this.getPresetCategoryValue(props),
    };
  }

  getPresetCategoryValue = (props = this.props) => {
    const queryParams = qs.parse(props.location.search);
    if (queryParams && queryParams.category) {
      const category = categories.find(c => c.name === (queryParams.category));
      if (category) return category;
    }
    return categories[0];
  }

  render() {
    const { classes, features, formatMessage } = this.props;
    const { category } = this.state;

    return (
      <BasicMain>
        <Typography className={classes.bottomSpacing} variant="h4" align="center" color="textPrimary">
          {/* {formatMessage('Features')} */}
        </Typography>
        <div className={classes.actions}>
          {categories.map(({ label, mobileLabel, name }) => (
            <Button
              variant={name === category.name ? 'contained' : 'outlined'}
              color="primary"
              className={classes.button}
              key={name}
              onClick={() => this.setState({ category: { label, name } })}
              disableRipple
            >
              {formatMessage(isMobile ? mobileLabel : label)}
            </Button>
          ))}
        </div>
        <Row>
          {features
            .filter(feature => feature.category === category.name)
            .map(feature => (
              <Col key={feature.title} xs="12" md="6" lg="4" className={classes.bottomSpacing}>
                <ProductCard
                  feature={feature}
                  formatMessage={formatMessage}
                />
              </Col>
            ))
          }
        </Row>
      </BasicMain>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('options', 'features')(state),
});

export default compose(
  setDisplayName('Products'),
  connect(
    mapStateToProps,
  ),
  injectIntl,
  immutableToJS,
  withStyles(styles),
  withTracker,
)(Products);
